import React from "react";
import { SparklesIcon } from "@heroicons/react/24/outline";
import styles from "./SubscriptionStatusChip.module.css";

export type SubscriptionPlan = "premium" | "premium_plus" | string | null | undefined;

interface SubscriptionStatusChipProps {
  plan: SubscriptionPlan;
  className?: string;
  size?: "default" | "compact";
  showIcon?: boolean;
}

const getPlanLabel = (plan: SubscriptionPlan) =>
  plan === "premium_plus" ? "Premium Plus" : "Premium";

const SubscriptionStatusChip: React.FC<SubscriptionStatusChipProps> = ({
  plan,
  className = "",
  size = "default",
  showIcon = true,
}) => {
  if (!plan) return null;

  const isPlus = plan === "premium_plus";
  const classes = [
    styles.statusChip,
    isPlus ? styles.statusChipPlus : styles.statusChipPremium,
    size === "compact" ? styles.statusChipCompact : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes}>
      {showIcon && <SparklesIcon className={styles.statusIcon} aria-hidden="true" />}
      <span>{getPlanLabel(plan)}</span>
    </span>
  );
};

export default SubscriptionStatusChip;
